import { RootState } from '@client/types'

export const getModal = (state: RootState) => state.modal
